import { formsApi } from "../../../services/api/formsApi";

export const invalidateFormsOnSuccess = async (
  _,
  { dispatch, queryFulfilled },
) => {
  await queryFulfilled;
  dispatch(formsApi.util.invalidateTags(["Form"]));
};
